import { Link } from "react-router-dom";
import { Mountain, Mail, Phone, MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export function Footer() {
  const { settings } = useSite();
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A1A10] text-white/70 sr-grain overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 max-w-sm">
          <Link to="/" className="flex items-center gap-2.5 text-white mb-5">
            <span className="grid place-items-center h-9 w-9 rounded-full bg-[#1B4D2E] border border-[#D4AF37]/40">
              <Mountain className="h-5 w-5 text-[#D4AF37]" />
            </span>
            <span className="font-serif-display text-xl font-bold">{settings.site_title || "Saklı Rota"}</span>
          </Link>
          <p className="text-sm leading-relaxed">
            Türkiye'nin saklı kalmış güzelliklerini keşfetmenin en akıllı yolu. Şelaleler, göller, yaylalar ve
            binlerce destinasyon cebinde.
          </p>
        </div>

        <div>
          <h4 className="font-mono-accent text-xs uppercase tracking-widest text-[#D4AF37] mb-4">Sayfalar</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/premium" className="hover:text-white transition-colors" data-testid="footer-premium">Premium</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact">İletişim</Link></li>
            <li><Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Gizlilik Politikası</Link></li>
            <li><Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Kullanım Koşulları</Link></li>
            <li><Link to="/account-deletion" className="hover:text-white transition-colors" data-testid="footer-deletion">Hesap Silme Talebi</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono-accent text-xs uppercase tracking-widest text-[#D4AF37] mb-4">İletişim</h4>
          <ul className="space-y-3 text-sm">
            {settings.contact_email && (
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-[#40916C]" /> {settings.contact_email}</li>
            )}
            {settings.contact_phone && (
              <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-[#40916C]" /> {settings.contact_phone}</li>
            )}
            {settings.contact_address && (
              <li className="flex items-center gap-2.5"><MapPin className="h-4 w-4 text-[#40916C]" /> {settings.contact_address}</li>
            )}
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {settings.site_title || "Saklı Rota"}. Tüm hakları saklıdır.</p>
          <p className="font-mono-accent">www.saklirota.com</p>
        </div>
      </div>
    </footer>
  );
}
